module.exports = __webpack_public_path__ + "5a5ef1e0fe5c14b42beac5efbdff2e96.png";